var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { compose, graphql, MultiStepWizard, PageLayout, withAnalytics, withFeatureFlags, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withShowFlag } from "@atlassiansox/microscopekit";
import { useLocation, withRouter } from "react-router-dom";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import serviceQuery from "../graphql/service.query.graphql";
import { WargameCategory } from "../../__generated__/graphql-global-types";
import { FirstFormFc } from "../components/FormView/FirstFormFc";
import "@atlaskit/css-reset/dist/bundle.css";
import { SecondForm } from "../components/FormView/SecondForm";
import { PremiseFormFc } from "../components/FormView/PremiseForm";
import TaskGroupFormWrapper from "../components/FormView/TaskGroupFormWrapper";
import TemplatePreview from "../components/TemplatePreview";
import TemplateDetailsQuery from "../graphql/template-details.query.graphql";
import { PublishStatusFormFc } from "../components/FormView/PublishTemplateForm";
import ServiceContainersQuery from "../graphql/service-containers.query.graphql";
import ServiceMicrosGroupsQuery from "../graphql/service-micros-group.query.graphql";
import { usePremise } from "../hooks/createTemplatePage";
import { updatePremiseRequestMethod } from "../models/Premise";
import { BaselineForServiceQuery } from "../graphql";
import { useAnalytics, useSendScreenEvent } from "../analytics";
import { usePollingQuery } from "../hooks";
function useQuery() {
    return new URLSearchParams(useLocation().search);
}
var CreateWargameTemplateView = function (props) {
    var _a = __read(useState({}), 2), wargameTemplate = _a[0], setWargameTemplate = _a[1];
    var isTemplateLoading = props.templateDetailsData.loading;
    var premiseFormRef = React.useRef(null);
    var templatePreviewRef = React.useRef(null);
    var _b = __read(useState(false), 2), isFirstFormValid = _b[0], setIsFirstFormValid = _b[1];
    var _c = __read(useState(false), 2), isSecondFormValid = _c[0], setIsSecondFormValid = _c[1];
    var _d = __read(useState(false), 2), isTaskGroupFormValid = _d[0], setIsTaskGroupFormValid = _d[1];
    var sendUIEvent = useAnalytics().sendUIEvent;
    useSendScreenEvent("createWargamePlanScreen");
    var data = usePollingQuery(BaselineForServiceQuery, {
        variables: { service: props.id }
    }, !isTaskGroupFormValid).data;
    useEffect(function () {
        var _a, _b, _c;
        if (!props.templateDetailsData.loading &&
            props.templateDetailsData.warGameTemplate !== undefined) {
            var tmpWargameTemplate = props.templateDetailsData.warGameTemplate;
            tmpWargameTemplate.name = (_a = wargameTemplate.name) !== null && _a !== void 0 ? _a : "Copy of " + tmpWargameTemplate.name;
            tmpWargameTemplate.environment = (_b = wargameTemplate.environment) !== null && _b !== void 0 ? _b : tmpWargameTemplate.environment;
            updatePremiseRequestMethod((_c = tmpWargameTemplate.premise) === null || _c === void 0 ? void 0 : _c[0]);
            setWargameTemplate(tmpWargameTemplate);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.templateDetailsData]);
    var parentTemplateId = useQuery().get("parent_id");
    useEffect(function () {
        if (parentTemplateId != null) {
            props.templateDetailsData.refetch({
                id: parentTemplateId,
                skip: false
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parentTemplateId]);
    var multiStepWizardRef = useRef(null);
    var goToNextStep = function () { var _a; return (_a = multiStepWizardRef.current) === null || _a === void 0 ? void 0 : _a.onNext(); };
    var _e = usePremise(wargameTemplate, setWargameTemplate), premise = _e.premise, premiseBeingEdited = _e.premiseBeingEdited, setPremiseBeingEdited = _e.setPremiseBeingEdited, startEditing = _e.startEditing, stopEditing = _e.stopEditing, isPremiseFormWizardButtonDisabled = _e.isPremiseFormWizardButtonDisabled, submit = _e.submit, deletePremise = _e.deletePremise;
    return (React.createElement(PageLayout, { title: "" },
        React.createElement(MultiStepWizard, { steps: [
                {
                    name: "Introduction",
                    body: (React.createElement(FirstFormFc, { wargameTemplate: wargameTemplate, setIsFormValid: setIsFirstFormValid, serviceId: props.id })),
                    onNext: function () {
                        props.serviceContainersData.refetch({
                            service: props.id,
                            env: wargameTemplate.environment,
                            skip: false
                        });
                        props.serviceMicrosContainerData.refetch({
                            service: props.id,
                            environment: wargameTemplate.environment,
                            skip: false
                        });
                    },
                    nextDisabled: isFirstFormValid ? undefined : "disable"
                },
                {
                    name: "Template Library",
                    body: (React.createElement(SecondForm, { wargameTemplate: wargameTemplate, setFormValid: setIsSecondFormValid })),
                    onNext: function () {
                        var _a;
                        sendUIEvent({
                            source: "createWargamePlanTemplateSelectionStep",
                            actionSubject: "button",
                            action: "clicked",
                            actionSubjectId: "templateSelection",
                            attributes: {
                                templatetype: wargameTemplate.category,
                                templateId: (_a = wargameTemplate === null || wargameTemplate === void 0 ? void 0 : wargameTemplate.wargameParent) !== null && _a !== void 0 ? _a : null
                            }
                        });
                        if (wargameTemplate.category === WargameCategory.default) {
                            props.templateDetailsData
                                .refetch({ id: wargameTemplate.wargameParent, skip: false })
                                .finally(function () {
                                var _a;
                                (_a = premiseFormRef.current) === null || _a === void 0 ? void 0 : _a.refresh(wargameTemplate);
                            });
                        }
                    },
                    nextDisabled: isSecondFormValid ? undefined : "disable"
                },
                {
                    name: "Premise Setup",
                    body: (React.createElement(PremiseFormFc, { premise: premise, premiseBeingEdited: premiseBeingEdited, setPremiseBeingEdited: setPremiseBeingEdited, isLoading: isTemplateLoading, deletePremise: deletePremise, submit: submit, startEditing: startEditing, stopEditing: stopEditing, onSkip: goToNextStep, environment: wargameTemplate.environment })),
                    nextDisabled: getNextDisabled(isPremiseFormWizardButtonDisabled),
                    backDisabled: getNextDisabled(isPremiseFormWizardButtonDisabled)
                },
                {
                    name: "Task Groups",
                    body: (React.createElement(TaskGroupFormWrapper, { wargameTemplate: wargameTemplate, setIsFormValid: setIsTaskGroupFormValid, containersForService: props.serviceContainersData.containersForService, microsGroupsForService: props.serviceMicrosContainerData.microsGroupsForService, serviceId: props.id, environment: wargameTemplate.environment, baseline: data })),
                    nextDisabled: isTaskGroupFormValid ? undefined : "disable"
                },
                {
                    name: "Preview",
                    body: (React.createElement(TemplatePreview, { wargameTemplate: wargameTemplate, ref: templatePreviewRef })),
                    onNext: function () {
                        console.log("onNext");
                    }
                },
                {
                    name: "Confirmation",
                    body: (React.createElement(PublishStatusFormFc, { wargameTemplate: wargameTemplate, serviceId: props.id }))
                }
            ], title: "Create Wargame Plan", ref: multiStepWizardRef })));
};
// Use the `compose` function to wrap decorators around your component. These will run before your component code does.
export var ResilienceCreatePage = compose(graphql(serviceQuery, {}), graphql(TemplateDetailsQuery, {
    name: "templateDetailsData",
    options: function (_a) {
        var templateId = _a.templateId;
        return ({
            query: TemplateDetailsQuery,
            variables: { id: templateId, skip: true }
        });
    }
}), graphql(ServiceContainersQuery, {
    name: "serviceContainersData",
    options: function (_a) {
        var id = _a.id, environment = _a.environment;
        return ({
            query: ServiceContainersQuery,
            variables: { service: id, env: environment, skip: true }
        });
    }
}), graphql(ServiceMicrosGroupsQuery, {
    name: "serviceMicrosContainerData",
    options: function (_a) {
        var id = _a.id, environment = _a.environment;
        return ({
            query: ServiceMicrosGroupsQuery,
            variables: { service: id, environment: environment, skip: true }
        });
    }
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withFeatureFlags, withAnalytics, withRouter, withMountTracking("Credo.CredoPage"))(CreateWargameTemplateView);
var getNextDisabled = function (isNextDisabled) {
    return isNextDisabled ? "disable" : undefined;
};
